import React, {  useState } from "react";
import {  Container, Tab, Tabs } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import TouristVisaAdmin from "./Visa";
import TouristRsdenceAdmin from "./resdence";
const AllTouritsType = () => {
  const [key, setKey] = useState("visa");
  return (
    <div className="tabss">
      <Container>
        <h4 className="text-center mt-3 mb-3">إدارة الأقامة والفيزا</h4>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="visa"  title="الفيزا">
           <TouristVisaAdmin keyy={key}/>         
          </Tab>
          <Tab eventKey="residence" title="الاقامة">
           <TouristRsdenceAdmin keyy={key}/>
          </Tab>
          {/* <Tab eventKey="req" title="الطلبات">
            <Reqcar />
          </Tab> */}
        </Tabs>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default AllTouritsType;
